import React from 'react'

const About = () => {
  return (
    <div>
      <h1 className='center fw-bolder fs-30'>About</h1>
    </div>
  )
}

export default About